import { GeneralProps } from './index';
import { ReduxSelectorProps } from '../../services/constants';
import { useEffect, useState } from 'react';
import './../text-editor/style.scss';

export const General = ({
  open,
  Description,
  ...generalData
}: GeneralProps &
  ReduxSelectorProps & {
    Description: string;
    open: boolean;
  }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(open);

  useEffect(() => {
    setIsDropdownOpen(open);
  }, [open]);

  return (
    <>
      <div className="pt-2 text-editor-content ">
        <div
          className="mx-auto max-w-2xl text-center mb-6 cursor-pointer"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
          {generalData.Title && (
            <div className="flex gap-0.5">
              {isDropdownOpen ? '-' : '+'}
              <div
                style={{ lineHeight: 1.5 }}
                dangerouslySetInnerHTML={{ __html: generalData.Title }}
              />
            </div>
          )}
        </div>
        {isDropdownOpen && (
          <div
            style={{ lineHeight: 1.5 }}
            className="checkbox-text ml-3 !bg-none text-left text-black"
            dangerouslySetInnerHTML={{ __html: Description }}
          />
        )}
      </div>
    </>
  );
};
